import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlp6TipsF = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17381" data-mp="o6meoyve9s0c">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17382" data-mp="f7iv7tsbfalb"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17383" data-mp="f9lrgvk29zyh">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17384" data-mp="1bwqgd0p0vhop">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17385" data-mp="17wzjqgcte7c9">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17386" data-mp="1333o3kk0wwk9">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17387" data-mp="1vn27ik9p4r52">
          <div className="text-left" data-id="element-17388" data-mp="1qsy3a8rtex7o">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17389" data-mp="2f53fj4io8nx0">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17390" data-mp="1wbzhl6yf7owl">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17391" data-mp="1nde2jls5qs0k">
        <div className="max-w-4xl mx-auto" data-id="element-17392" data-mp="1re7qug9ii8tz">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17393" data-mp="1rez9kqi0gc2u">
            PERSONAL REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-2" data-id="element-17394" data-mp="3lryyja8a6ims">
            Before You Take Your Next GLP-1 Shot, Read This
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17395" data-mp="yhf0udz50m5h">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17396" data-mp="tjdijv9jcqv2">
              <img src="https://cdn.magicpatterns.com/uploads/qo1VVrn8u2FTESbwCETPV1/1.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17397" data-mp="pkxwpup6xoj8" />
            </div>
            <div className="flex-1" data-id="element-17398" data-mp="1h9rc5q7rqxrr">
              <div className="flex items-center" data-id="element-17399" data-mp="1d8nuqza2otof">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17400" data-mp="1d9ywktjyjrcw">
                  By Patricia Morrison, RN, CN
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17401" data-mp="18fmcchanqc03">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17402" data-mp="13icov76twaew" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17403" data-mp="20yrzxb2wt1hj">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17404" data-mp="1w6id43x3chjh">
                Chicago, IL • Former Medical Practitioner • 58 Years Old • 4
                Years on GLP-1 Medications
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17405" data-mp="28iu5xcgnu9b0">
                <div className="flex items-center mr-4" data-id="element-17406" data-mp="2dh40bkuk95vk">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17407" data-mp="2dfkms20ah8xh" />
                  <span data-id="element-17408" data-mp="2hipnbz0t70jh">18 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17409" data-mp="2hg4jj4gyaaj3">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17410" data-mp="2mgiouer636df" />
                  <span data-id="element-17411" data-mp="2rgn8gdndgh7v">42,372 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17412" data-mp="2rekcze3g9vvr">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17413" data-mp="2w7vjfe4coan5" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17414" data-mp="3189kudbg4mc7">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <div className="my-4" data-id="element-17415" data-mp="3a7eilhf6obnb">
            <img src="https://cdn.magicpatterns.com/uploads/nwn6hondxNojcsAjvGQfEj/2.png" alt="Before and after transformation" className="w-full rounded-lg shadow-lg mb-3" data-id="element-17416" data-mp="2wk5zz4sjarve" />
            <div className="flex justify-between items-center px-2 py-1 bg-gray-50 rounded border-t border-gray-200" data-id="element-17417" data-mp="2sgzva1l2l8r1">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17418" data-mp="31be87xi4o76z">
                September 25, 2021
              </span>
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wide" data-id="element-17419" data-mp="2dmbjy6szng3i">
                December 7, 2025
              </span>
            </div>
          </div>

          <div className="my-4 border-l-4 border-gray-800 pl-6 py-4 bg-gradient-to-r from-gray-100 to-white shadow-sm" data-id="element-17420" data-mp="2njzmvk0qztwr">
            <p className="text-sm uppercase tracking-wide text-gray-500 mb-2 font-semibold" data-id="element-17421" data-mp="2ijv2vk0msh1s">
              ARTICLE SUMMARY
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic" data-id="element-17422" data-mp="2vbk9essr0nd">
              "What a Chicago nurse discovered after three years of crushing
              depression on semaglutide:
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17423" data-mp="1krn3p3371mn7">
              6 science-backed strategies that address nausea, hair loss,
              fatigue, and the devastating 'flat feeling' without stopping your
              medication....
            </p>
            <p className="text-base leading-relaxed text-gray-800 font-serif italic mt-4" data-id="element-17424" data-mp="1zg9tjyqg5wso">
              — now helping 120+ GLP-1 users monthly at her weight loss clinic."
            </p>
          </div>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17425" data-mp="1pqggetanp9mb">
            <div className="mb-1 flex items-center" data-id="element-17426" data-mp="1uorvbift6abe">
              <span className="font-medium mr-2" data-id="element-17427" data-mp="1un6w3fiju377">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17428" data-mp="2n5ccd9wthvor">
              <span className="font-medium mr-2" data-id="element-17429" data-mp="2n6x5cv3hh6ki">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlp6TipsF;